import { apiSalesWeb } from '@shared/config';
import { DocumentTypeEnum } from '@shared/types/PersonType';

export interface ICreateRequestCustomerInput {
  documentType: DocumentTypeEnum;
  documentNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface ICreateRequestCustomerOutput {
  id: string;
}

export function createRequestCustomer({
  ...payload
}: ICreateRequestCustomerInput) {
  return apiSalesWeb.post<ICreateRequestCustomerOutput>(
    '/request-customer',
    payload,
  );
}
